

















import { Component, Vue } from 'vue-property-decorator';
import { isiOS } from '@/utils/common';

@Component({
  name: 'AppToAlipay'
})

export default class AppToAlipay extends Vue {
  created() {
    document.title = '俏租机';
  }

  // 跳转到支付宝
  goToAlipay() {
    if (isiOS()) {
      window.location.href = 'https://ds.alipay.com/?scheme=alipays%3A%2F%2Fplatformapi%2Fstartapp%3FappId%3D2021001155694219%26page%3D%2FpagesA%2Factivity%2FnewActivity%26query%3Dscene%253D3068%2526magicId%253D1402816078475825152';
    } else {
      window.location.href = 'https://ds.alipay.com/?scheme=alipays%3A%2F%2Fplatformapi%2Fstartapp%3FappId%3D2021001155694219%26page%3D%2FpagesA%2Factivity%2FnewActivity%26query%3Dscene%253D3068001%2526magicId%253D1402816078475825152';
    }
  }
}
